import { useMediaQueries } from 'builder/hooks/useMediaQueries'

import * as Styles from './styles'
import IlustrationImg from './assets/ilustration.png'
import IlustrationMobileImg from './assets/ilustration-mobile.png'

type IlustrationBoxProps = {
  status: 'initial' | 'progress'
  recruitersCount?: number
  recruitersText?: string
}

export const IlustrationBox = ({
  status,
  recruitersCount,
  recruitersText,
}: IlustrationBoxProps) => {
  const { isPhone } = useMediaQueries()

  if (status === 'initial') {
    return (
      <Styles.IlustrationContainer data-testid={`resume-distribution-ilustration-box-${status}`}>
        <Styles.IlustrationImage src={isPhone ? IlustrationMobileImg : IlustrationImg} />
      </Styles.IlustrationContainer>
    )
  }
  return (
    <Styles.IlustrationContainer data-testid={`resume-distribution-ilustration-box-${status}`}>
      <Styles.IlustrationOuterCircle>
        <Styles.RdLogo />
        <Styles.IlustrationInnerCircle>
          <Styles.RecruitersCountContainer>
            <Styles.CountContainer>
              <Styles.CountText data-testid="resume-distribution-recruiters-count">
                {recruitersCount}
              </Styles.CountText>
              <Styles.UpperIconContainer>
                <Styles.UpperIcon />
              </Styles.UpperIconContainer>
            </Styles.CountContainer>
            <Styles.RecruitersText data-testid="resume-distribution-recruiters-text">
              {recruitersText}
            </Styles.RecruitersText>
          </Styles.RecruitersCountContainer>
        </Styles.IlustrationInnerCircle>
      </Styles.IlustrationOuterCircle>
    </Styles.IlustrationContainer>
  )
}
